module.exports = __webpack_public_path__ + "img/demo_0.4ec8a69f.gif";